export default {
  // Common
  'common.codeExample': 'कोड उदाहरण',
  'common.tryItYourself': 'स्वयं प्रयास करें',
  'common.output': 'आउटपुट',
  'common.explanation': 'स्पष्टीकरण',
  'common.bestPractices': 'सर्वोत्तम प्रथाएं',
  'common.commonMistakes': 'सामान्य गलतियाँ',
  'common.relatedFunctions': 'संबंधित फ़ंक्शन',

  // MySQL Timestamp Page
  'mysql.mainTitle': 'MySQL टाइमस्टैम्प संपूर्ण गाइड',
  'mysql.mainTitleSEO': 'MySQL टाइमस्टैम्प ट्यूटोरियल - UNIX_TIMESTAMP और FROM_UNIXTIME गाइड',
  'mysql.subtitle': 'MySQL टाइमस्टैम्प फ़ंक्शन, डेटा प्रकार और टाइमज़ोन हैंडलिंग में महारत हासिल करें',

  'mysql.intro': 'MySQL Unix टाइमस्टैम्प के साथ काम करने के लिए शक्तिशाली फ़ंक्शन प्रदान करता है। यह गाइड बुनियादी टाइमस्टैम्प फ़ंक्शन से लेकर उन्नत टाइमज़ोन हैंडलिंग तक सब कुछ कवर करती है।',

  // UNIX_TIMESTAMP() Section
  'mysql.unixTimestampTitle': 'UNIX_TIMESTAMP() फ़ंक्शन',
  'mysql.unixTimestampDesc': 'तारीख/डेटाटाइम को Unix टाइमस्टैम्प में कन्वर्ट करता है (1970-01-01 00:00:00 UTC के बाद से सेकंड)',
  'mysql.getCurrentTimestamp': 'वर्तमान Unix टाइमस्टैम्प प्राप्त करें',
  'mysql.convertDateToTimestamp': 'तारीख को टाइमस्टैम्प में कन्वर्ट करें',
  'mysql.example1': 'सेकंड में वर्तमान Unix टाइमस्टैम्प लौटाता है',
  'mysql.example2': 'विशिष्ट डेटाटाइम को टाइमस्टैम्प में कन्वर्ट करें',

  // FROM_UNIXTIME() Section
  'mysql.fromUnixtimeTitle': 'FROM_UNIXTIME() फ़ंक्शन',
  'mysql.fromUnixtimeDesc': 'Unix टाइमस्टैम्प को MySQL डेटाटाइम प्रारूप में कन्वर्ट करता है',
  'mysql.convertTimestampToDate': 'टाइमस्टैम्प को डेटाटाइम में कन्वर्ट करें',
  'mysql.formatTimestamp': 'कस्टम पैटर्न के साथ टाइमस्टैम्प को प्रारूपित करें',

  // TIMESTAMP vs DATETIME
  'mysql.typesTitle': 'TIMESTAMP बनाम DATETIME डेटा प्रकार',
  'mysql.timestampType': 'TIMESTAMP प्रकार',
  'mysql.timestampFeature1': 'रेंज: 1970-01-01 से 2038-01-19',
  'mysql.timestampFeature2': 'UTC में संग्रहीत, स्थानीय टाइमज़ोन में कन्वर्ट किया गया',
  'mysql.timestampFeature3': 'INSERT/UPDATE पर स्वचालित रूप से अपडेट होता है',
  'mysql.timestampFeature4': '4 बाइट्स संग्रहण का उपयोग करता है',

  'mysql.datetimeType': 'DATETIME प्रकार',
  'mysql.datetimeFeature1': 'रेंज: 1000-01-01 से 9999-12-31',
  'mysql.datetimeFeature2': 'जैसा है वैसा संग्रहीत, कोई टाइमज़ोन रूपांतरण नहीं',
  'mysql.datetimeFeature3': 'मैन्युअल रूप से अपडेट किया गया',
  'mysql.datetimeFeature4': '8 बाइट्स संग्रहण का उपयोग करता है',

  // Practical Examples
  'mysql.practicalTitle': 'व्यावहारिक SQL उदाहरण',
  'mysql.example.insert': 'वर्तमान टाइमस्टैम्प डालें',
  'mysql.example.query': 'टाइमस्टैम्प रेंज द्वारा रिकॉर्ड क्वेरी करें',
  'mysql.example.update': 'टाइमस्टैम्प कॉलम अपडेट करें',
  'mysql.example.aggregation': 'टाइमस्टैम्प एग्रीगेशन',

  // Timezone Handling
  'mysql.timezoneTitle': 'MySQL में टाइमज़ोन हैंडलिंग',
  'mysql.timezoneDesc': 'MySQL TIMESTAMP मानों को UTC में संग्रहीत करता है और उन्हें कनेक्शन टाइमज़ोन में कन्वर्ट करता है',
  'mysql.setTimezone': 'सत्र टाइमज़ोन सेट करें',
  'mysql.convertTimezone': 'टाइमज़ोन के बीच कन्वर्ट करें',

  // Common Use Cases
  'mysql.useCasesTitle': 'सामान्य उपयोग के मामले',
  'mysql.useCase1.title': 'रिकॉर्ड निर्माण समय ट्रैक करें',
  'mysql.useCase1.desc': 'स्वचालित रूप से निर्माण समय सेट करने के लिए DEFAULT CURRENT_TIMESTAMP का उपयोग करें',

  'mysql.useCase2.title': 'अंतिम अपडेट समय ट्रैक करें',
  'mysql.useCase2.desc': 'स्वचालित रूप से संशोधन समय अपडेट करने के लिए ON UPDATE CURRENT_TIMESTAMP का उपयोग करें',

  'mysql.useCase3.title': 'तारीख रेंज द्वारा फ़िल्टर करें',
  'mysql.useCase3.desc': 'टाइमस्टैम्प रेंज द्वारा रिकॉर्ड फ़िल्टर करने के लिए UNIX_TIMESTAMP() का उपयोग करें',

  'mysql.useCase4.title': 'समय अवधि द्वारा समूह',
  'mysql.useCase4.desc': 'रिकॉर्ड को समूहीकृत करने के लिए DATE_FORMAT() के साथ FROM_UNIXTIME() का उपयोग करें',

  // Performance Tips
  'mysql.performanceTitle': 'प्रदर्शन अनुकूलन युक्तियाँ',
  'mysql.perf1': 'WHERE क्लॉज में उपयोग किए गए टाइमस्टैम्प कॉलम को इंडेक्स करें',
  'mysql.perf2': 'टाइमज़ोन रूपांतरण की आवश्यकता वाले कॉलम के लिए TIMESTAMP का उपयोग करें',
  'mysql.perf3': 'TIMESTAMP रेंज के बाहर ऐतिहासिक तारीखों के लिए DATETIME का उपयोग करें',
  'mysql.perf4': 'WHERE क्लॉज में फ़ंक्शन का उपयोग करने से बचें - इंडेक्स किए गए कॉलम का उपयोग करें',

  // FAQ
  'mysql.faq.q1': 'MySQL में वर्ष 2038 समस्या क्या है?',
  'mysql.faq.a1': 'TIMESTAMP एक हस्ताक्षरित 32-बिट पूर्णांक का उपयोग करता है, जो 19 जनवरी 2038 को ओवरफ्लो हो जाएगा। 2038 से परे तारीखों के लिए DATETIME का उपयोग करें।',

  'mysql.faq.q2': 'MySQL में मिलीसेकंड कैसे संग्रहीत करें?',
  'mysql.faq.a2': 'मिलीसेकंड में Unix टाइमस्टैम्प संग्रहीत करने के लिए BIGINT का उपयोग करें, या मिलीसेकंड सटीकता के साथ डेटाटाइम के लिए DATETIME(3) का उपयोग करें।',

  'mysql.faq.q3': 'मुझे TIMESTAMP या DATETIME का उपयोग करना चाहिए?',
  'mysql.faq.a3': 'टाइमज़ोन जागरूकता के साथ हाल की तारीखों के लिए TIMESTAMP का उपयोग करें। ऐतिहासिक तारीखों के लिए या जब टाइमज़ोन रूपांतरण की आवश्यकता न हो तो DATETIME का उपयोग करें।',

  'mysql.faq.q4': 'MySQL में टाइमज़ोन को कैसे संभालें?',
  'mysql.faq.a4': 'TIMESTAMP प्रकार का उपयोग करके सभी टाइमस्टैम्प को UTC में संग्रहीत करें, फिर प्रदर्शित करते समय स्थानीय टाइमज़ोन में कन्वर्ट करें।',

  // Python Timestamp Page
  'python.mainTitle': 'Python टाइमस्टैम्प संपूर्ण गाइड',
  'python.mainTitleSEO': 'Python टाइमस्टैम्प ट्यूटोरियल - datetime, time, calendar मॉड्यूल गाइड',
  'python.subtitle': 'datetime, time और calendar मॉड्यूल के साथ Python टाइमस्टैम्प हैंडलिंग में महारत हासिल करें',

  'python.intro': 'Python टाइमस्टैम्प के साथ काम करने के लिए कई मॉड्यूल प्रदान करता है। यह व्यापक गाइड time, datetime, calendar और टाइमज़ोन हैंडलिंग को कवर करती है।',

  // Get Current Timestamp
  'python.getCurrentTitle': 'वर्तमान Unix टाइमस्टैम्प प्राप्त करें',
  'python.getCurrentDesc': 'Python में वर्तमान Unix टाइमस्टैम्प प्राप्त करने के कई तरीके',
  'python.method1': 'time.time() का उपयोग करना - फ्लोट लौटाता है',
  'python.method2': 'datetime.now() का उपयोग करना - पूर्णांक लौटाता है',
  'python.method3': 'calendar मॉड्यूल का उपयोग करना',

  // Convert Timestamp to Datetime
  'python.toDatetimeTitle': 'टाइमस्टैम्प को डेटाटाइम में कन्वर्ट करें',
  'python.toDatetimeDesc': 'Unix टाइमस्टैम्प को Python डेटाटाइम ऑब्जेक्ट में कन्वर्ट करें',
  'python.fromTimestamp': 'datetime.fromtimestamp() का उपयोग करना',
  'python.formatDatetime': 'डेटाटाइम स्ट्रिंग को प्रारूपित करें',
  'python.timezoneAware': 'टाइमज़ोन-जागरूक डेटाटाइम',

  // Convert Datetime to Timestamp
  'python.toTimestampTitle': 'डेटाटाइम को टाइमस्टैम्प में कन्वर्ट करें',
  'python.toTimestampDesc': 'Python डेटाटाइम ऑब्जेक्ट को Unix टाइमस्टैम्प में कन्वर्ट करें',
  'python.usingTimestamp': '.timestamp() विधि का उपयोग करना',
  'python.usingMktime': 'time.mktime() का उपयोग करना',

  // Timezone Handling
  'python.timezoneTitle': 'टाइमज़ोन हैंडलिंग',
  'python.timezoneDesc': 'pytz और zoneinfo का उपयोग करके टाइमज़ोन के साथ काम करना',
  'python.pytzExample': 'pytz लाइब्रेरी का उपयोग करना',
  'python.zoneinfoExample': 'zoneinfo का उपयोग करना (Python 3.9+)',

  // Common Patterns
  'python.patternsTitle': 'सामान्य पैटर्न और उपयोग के मामले',
  'python.pattern1.title': 'टाइमस्टैम्प अंकगणित',
  'python.pattern1.desc': 'टाइमस्टैम्प से समय जोड़ें या घटाएं',

  'python.pattern2.title': 'टाइमस्टैम्प की तुलना करें',
  'python.pattern2.desc': 'समय अंतर खोजने के लिए दो टाइमस्टैम्प की तुलना करें',

  'python.pattern3.title': 'राउंड टाइमस्टैम्प',
  'python.pattern3.desc': 'टाइमस्टैम्प को निकटतम दिन/घंटा/मिनट तक राउंड करें',

  'python.pattern4.title': 'स्ट्रिंग को टाइमस्टैम्प में पार्स करें',
  'python.pattern4.desc': 'तारीख स्ट्रिंग को टाइमस्टैम्प में कन्वर्ट करें',

  // JavaScript Timestamp Page
  'javascript.mainTitle': 'JavaScript टाइमस्टैम्प संपूर्ण गाइड',
  'javascript.mainTitleSEO': 'JavaScript टाइमस्टैम्प ट्यूटोरियल - Date ऑब्जेक्ट और विधियाँ गाइड',
  'javascript.subtitle': 'JavaScript Date ऑब्जेक्ट, टाइमस्टैम्प विधियों और टाइमज़ोन हैंडलिंग में महारत हासिल करें',

  'javascript.intro': 'JavaScript टाइमस्टैम्प के साथ काम करने के लिए Date ऑब्जेक्ट प्रदान करता है। यह गाइड बुनियादी विधियों से लेकर उन्नत टाइमज़ोन हैंडलिंग तक सब कुछ कवर करती है।',

  // Get Current Timestamp
  'javascript.getCurrentTitle': 'वर्तमान Unix टाइमस्टैम्प प्राप्त करें',
  'javascript.getCurrentDesc': 'JavaScript में वर्तमान टाइमस्टैम्प प्राप्त करने के कई तरीके',
  'javascript.dateNow': 'Date.now() का उपयोग करना - सबसे कुशल',
  'javascript.getTime': 'new Date().getTime() का उपयोग करना',
  'javascript.valueOf': 'valueOf() विधि का उपयोग करना',
  'javascript.unaryPlus': 'यूनरी + ऑपरेटर का उपयोग करना',

  // Convert Timestamp to Date
  'javascript.toDateTitle': 'टाइमस्टैम्प को तारीख में कन्वर्ट करें',
  'javascript.toDateDesc': 'Unix टाइमस्टैम्प को JavaScript Date ऑब्जेक्ट में कन्वर्ट करें',
  'javascript.newDate': 'टाइमस्टैम्प से Date बनाएं',
  'javascript.formatDate': 'तारीख स्ट्रिंग को प्रारूपित करें',
  'javascript.toLocaleString': 'प्रारूपण के लिए toLocaleString() का उपयोग करना',

  // Convert Date to Timestamp
  'javascript.toTimestampTitle': 'तारीख को टाइमस्टैम्प में कन्वर्ट करें',
  'javascript.toTimestampDesc': 'JavaScript Date को Unix टाइमस्टैम्प में कन्वर्ट करें',
  'javascript.parseDate': 'तारीख स्ट्रिंग को टाइमस्टैम्प में पार्स करें',
  'javascript.dateComponents': 'घटकों से टाइमस्टैम्प बनाएं',

  // Date Libraries
  'javascript.librariesTitle': 'लोकप्रिय तारीख लाइब्रेरी',
  'javascript.momentJs': 'Moment.js (विरासत)',
  'javascript.dayJs': 'Day.js (हल्का)',
  'javascript.dateFns': 'date-fns (आधुनिक)',
  'javascript.luxon': 'Luxon (टाइमज़ोन-जागरूक)',

  // Java & PHP - Similar structure
  'java.mainTitle': 'Java टाइमस्टैम्प संपूर्ण गाइड',
  'java.mainTitleSEO': 'Java टाइमस्टैम्प ट्यूटोरियल - Date, Calendar, Instant गाइड',
  'java.subtitle': 'Date, Calendar, Instant और LocalDateTime के साथ Java टाइमस्टैम्प हैंडलिंग में महारत हासिल करें',
  'java.intro': 'Java टाइमस्टैम्प के साथ काम करने के लिए कई API प्रदान करता है। यह गाइड विरासत Date/Calendar क्लासेस और आधुनिक java.time API (Java 8+) को कवर करती है।',

  // Get Current Timestamp
  'java.getCurrentTitle': 'वर्तमान Unix टाइमस्टैम्प प्राप्त करें',
  'java.getCurrentDesc': 'Java में वर्तमान टाइमस्टैम्प प्राप्त करने के कई तरीके',
  'java.method1': 'System.currentTimeMillis() का उपयोग करना - सबसे तेज़',
  'java.method2': 'Instant.now() का उपयोग करना - आधुनिक (Java 8+)',
  'java.method3': 'Date क्लास का उपयोग करना - विरासत',

  // Convert Timestamp to Date
  'java.toDateTitle': 'टाइमस्टैम्प को तारीख में कन्वर्ट करें',
  'java.toDateDesc': 'Unix टाइमस्टैम्प को Java Date/Instant/LocalDateTime में कन्वर्ट करें',
  'java.fromTimestamp': 'Instant.ofEpochSecond() का उपयोग करना',
  'java.toLocalDateTime': 'LocalDateTime में कन्वर्ट करें',
  'java.formatDate': 'DateTimeFormatter के साथ प्रारूपित करें',

  // Convert Date to Timestamp
  'java.toTimestampTitle': 'तारीख को टाइमस्टैम्प में कन्वर्ट करें',
  'java.toTimestampDesc': 'Java Date/Instant/LocalDateTime को Unix टाइमस्टैम्प में कन्वर्ट करें',
  'java.dateToTimestamp': 'Date.getTime() का उपयोग करना',
  'java.instantToTimestamp': 'Instant विधियों का उपयोग करना',

  // Timezone Handling
  'java.timezoneTitle': 'टाइमज़ोन हैंडलिंग',
  'java.timezoneDesc': 'ZoneId और ZonedDateTime का उपयोग करके टाइमज़ोन के साथ काम करना',
  'java.zoneIdExample': 'ZoneId का उपयोग करना',
  'java.zonedDateTimeExample': 'ZonedDateTime का उपयोग करना',

  // Common Patterns
  'java.patternsTitle': 'सामान्य Java टाइमस्टैम्प पैटर्न',
  'java.pattern1.title': 'तारीख अंकगणित',
  'java.pattern1.desc': 'Duration और Period का उपयोग करके समय जोड़ें या घटाएं',
  'java.pattern2.title': 'तारीख स्ट्रिंग पार्स करें',
  'java.pattern2.desc': 'DateTimeFormatter का उपयोग करके स्ट्रिंग को टाइमस्टैम्प में पार्स करें',
  'java.pattern3.title': 'टाइमस्टैम्प की तुलना करें',
  'java.pattern3.desc': 'तारीखों की तुलना करें और अंतर की गणना करें',

  'php.mainTitle': 'PHP टाइमस्टैम्प संपूर्ण गाइड',
  'php.mainTitleSEO': 'PHP टाइमस्टैम्प ट्यूटोरियल - time(), strtotime(), DateTime गाइड',
  'php.subtitle': 'time(), date(), strtotime() और DateTime क्लास के साथ PHP टाइमस्टैम्प हैंडलिंग में महारत हासिल करें',
  'php.intro': 'PHP टाइमस्टैम्प के साथ काम करने के लिए शक्तिशाली फ़ंक्शन प्रदान करता है। यह गाइड प्रक्रियात्मक फ़ंक्शन और ऑब्जेक्ट-ओरिएंटेड DateTime क्लास दोनों को कवर करती है।',

  // Get Current Timestamp
  'php.getCurrentTitle': 'वर्तमान Unix टाइमस्टैम्प प्राप्त करें',
  'php.getCurrentDesc': 'PHP में वर्तमान टाइमस्टैम्प प्राप्त करने के कई तरीके',
  'php.method1': 'time() का उपयोग करना - सबसे सामान्य',
  'php.method2': 'microtime() का उपयोग करना - माइक्रोसेकंड के साथ',
  'php.method3': 'DateTime क्लास का उपयोग करना',

  // Convert Timestamp to Date
  'php.toDateTitle': 'टाइमस्टैम्प को तारीख में कन्वर्ट करें',
  'php.toDateDesc': 'Unix टाइमस्टैम्प को प्रारूपित तारीख स्ट्रिंग में कन्वर्ट करें',
  'php.dateFunction': 'date() फ़ंक्शन का उपयोग करना',
  'php.dateTimeClass': 'DateTime क्लास का उपयोग करना',
  'php.formatDate': 'कस्टम तारीख प्रारूपण',

  // Convert Date to Timestamp
  'php.toTimestampTitle': 'तारीख को टाइमस्टैम्प में कन्वर्ट करें',
  'php.toTimestampDesc': 'तारीख स्ट्रिंग को Unix टाइमस्टैम्प में कन्वर्ट करें',
  'php.strtotime': 'strtotime() का उपयोग करना - अंग्रेजी टेक्स्ट पार्स करें',
  'php.dateTimeToTimestamp': 'DateTime::getTimestamp() का उपयोग करना',

  // Timezone Handling
  'php.timezoneTitle': 'टाइमज़ोन हैंडलिंग',
  'php.timezoneDesc': 'DateTimeZone का उपयोग करके टाइमज़ोन के साथ काम करना',
  'php.setTimezone': 'डिफ़ॉल्ट टाइमज़ोन सेट करें',
  'php.dateTimeZone': 'DateTimeZone क्लास का उपयोग करना',

  // Common Patterns
  'php.patternsTitle': 'सामान्य PHP टाइमस्टैम्प पैटर्न',
  'php.pattern1.title': 'तारीख अंकगणित',
  'php.pattern1.desc': 'strtotime() या DateInterval का उपयोग करके समय जोड़ें या घटाएं',
  'php.pattern2.title': 'सापेक्ष तारीखें पार्स करें',
  'php.pattern2.desc': '"अगला सोमवार", "पिछला सप्ताह", आदि पार्स करें',
  'php.pattern3.title': 'टाइमस्टैम्प की तुलना करें',
  'php.pattern3.desc': 'तारीखों की तुलना करें और अंतर की गणना करें',

  // SQL Timestamp Page (Universal - MySQL, PostgreSQL, Oracle, SQL Server)
  'sql.mainTitle': 'SQL टाइमस्टैम्प संपूर्ण गाइड',
  'sql.mainTitleSEO': 'SQL टाइमस्टैम्प ट्यूटोरियल - MySQL, PostgreSQL, Oracle, SQL Server',
  'sql.subtitle': 'MySQL, PostgreSQL, Oracle और SQL Server डेटाबेस में टाइमस्टैम्प हैंडलिंग में महारत हासिल करें',

  'sql.intro': 'विभिन्न SQL डेटाबेस में Unix टाइमस्टैम्प के साथ काम करना अलग-अलग होता है। यह व्यापक गाइड MySQL, PostgreSQL, Oracle और SQL Server के लिए टाइमस्टैम्प फ़ंक्शन को कवर करती है, जो आपको Unix टाइमस्टैम्प और डेटाबेस डेटाटाइम प्रारूपों के बीच कन्वर्ट करने में मदद करती है।',

  // Database Selection
  'sql.selectDatabase': 'अपना डेटाबेस चुनें',

  // Comparison
  'sql.comparisonTitle': 'त्वरित संदर्भ: डेटाबेस में टाइमस्टैम्प फ़ंक्शन',

  // Common Use Cases
  'sql.commonUseCases': 'सभी डेटाबेस में सामान्य उपयोग के मामले',
  'sql.useCase1.title': 'निर्माण टाइमस्टैम्प संग्रहीत करें',
  'sql.useCase1.desc': 'डिफ़ॉल्ट टाइमस्टैम्प मानों का उपयोग करके स्वचालित रूप से ट्रैक करें कि रिकॉर्ड कब बनाए जाते हैं',
  'sql.useCase2.title': 'अंतिम अपडेट समय ट्रैक करें',
  'sql.useCase2.desc': 'रिकॉर्ड बदलने पर स्वचालित रूप से संशोधन टाइमस्टैम्प अपडेट करें',
  'sql.useCase3.title': 'तारीख रेंज द्वारा फ़िल्टर करें',
  'sql.useCase3.desc': 'विश्लेषण और रिपोर्टिंग के लिए विशिष्ट टाइमस्टैम्प रेंज के भीतर रिकॉर्ड क्वेरी करें',
  'sql.useCase4.title': 'समय अवधि द्वारा समूह',
  'sql.useCase4.desc': 'टाइमस्टैम्प फ़ंक्शन का उपयोग करके घंटे, दिन, महीने या वर्ष द्वारा डेटा एकत्रित करें',

  // Best Practices
  'sql.bestPractice1': 'टाइमज़ोन भ्रम से बचने के लिए हमेशा UTC में टाइमस्टैम्प संग्रहीत करें',
  'sql.bestPractice2': 'बेहतर प्रदर्शन के लिए WHERE क्लॉज में अक्सर उपयोग किए जाने वाले टाइमस्टैम्प कॉलम को इंडेक्स करें',
  'sql.bestPractice3': 'जब संभव हो तो एप्लिकेशन कोड में कन्वर्ट करने के बजाय डेटाबेस-नेटिव फ़ंक्शन का उपयोग करें',
  'sql.bestPractice4': '32-बिट पूर्णांक टाइमस्टैम्प का उपयोग करते समय वर्ष 2038 समस्या के बारे में जागरूक रहें',
  'sql.bestPractice5': 'ओवरफ्लो समस्याओं से बचने के लिए मिलीसेकंड टाइमस्टैम्प के लिए BIGINT का उपयोग करें',
};
